import React from "react";
import { Result, Button } from "antd";

// گلیچ‌های گذرای DOM در Ant Design Table (removeChild / insertBefore)
// هنگام جابه‌جایی ستون انتخاب یا ورود به حالت ویرایش — نباید UI را بشکند.
function isTransientDomError(error) {
  const msg = String(error?.message || error || "");
  return /removeChild|insertBefore|NotFoundError|The node before which the new node is to be inserted is not a child/i.test(msg);
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    if (isTransientDomError(error)) return { hasError: false, error: null };
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (isTransientDomError(error)) {
      // بازیابی بی‌صدا در تیک بعدی تا جدول بدون «خطای موقت» بماند
      // eslint-disable-next-line no-console
      console.warn("ErrorBoundary suppressed DOM glitch:", error?.message);
      requestAnimationFrame(() => this.setState({ hasError: false, error: null }));
      return;
    }
    // eslint-disable-next-line no-console
    console.warn("ErrorBoundary caught:", error?.message, info?.componentStack?.split("\n")[1]?.trim());
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ padding: 24, direction: "rtl" }}>
        <Result
          status="warning"
          title="یک خطای موقت رخ داد"
          subTitle="نگران نباشید؛ اطلاعات‌تان محفوظ است. می‌توانید ادامه دهید یا صفحه را تازه کنید."
          extra={[
            <Button type="primary" key="retry" onClick={this.reset}>تلاش دوباره</Button>,
            <Button key="reload" onClick={() => window.location.reload()}>بارگذاری مجدد</Button>,
          ]}
        />
      </div>
    );
  }
}
